<template>
<AppLayout>
  <div class="home settings-users-page">
    <section id="settings-users">
        <div class="container settings-users-container">
            <h6 for="" class="fw-bold">1. Add user</h6>
            <div class="panel settings-users-panel">
                <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label for="address">System Role</label>
                        <select v-model="roleId" class="full form-control" id="roles"  v-if="roles.length > 0">
                            <option v-for="role in roles" v-bind:Key="role.id" :value="role.id">
                                {{ role.name }}
                            </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                        <label for="">Name</label>
                        <input type="text"  class="form-control" v-model="name" >
                    </div>
                   
                    <div class="col-md-2">
                        <label for="">Designation</label>
                        <input type="text"  class="form-control" v-model="designation" >
                    </div>
                    <div class="col-md-2">
                        <label for="">Employee Id No.</label>
                        <input type="text"  class="form-control" v-model="employeeId" >
                    </div>
                    <div class="col-md-2">
                        <div class="check-button">
                        <div class="form-group">
                            <label>System User?</label>
                            <div class="components-button">
                        <span class="switcher switcher-1">
                            <input type="checkbox" id="switcher-1" v-model="isSystemUser">
                            <label for="switcher-1"></label>
                        </span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <label for="">Upload ID</label>
                        <input type="file"  class="form-control" ref="fileUpload" @change="handleFileChange">
                    </div>
                    <div class="col-md-2">
                        <label for="">Upload Signature</label>
                        <input type="file"  class="form-control" ref="fileSignature" @change="handleFileChange">
                    </div>
                    <div class="col-md-2">
                        <label for="">Upload Passport Pciture</label>
                        <input type="file"  class="form-control" ref="filePicture" @change="handleFileChange">
                    </div>
                    <div class="col-md-2">
                        <label for="">Mobile Contact No. 1</label>
                        <input type="text" placeholder="Use +2547... (format)"  class="form-control" v-model="phone" >
                    </div>
                    <div class="col-md-2">
                        <label for="">Mobile Contact No. 2</label>
                        <input type="text" placeholder="Use +2547... (format)"  class="form-control" v-model="phone2" >
                    </div>
                    <div class="col-md-2">
                        <label for="">Email Address</label>
                        <input type="email"  class="form-control" v-model="email" >
                    </div>
                    <div class="col-md-2">
                        <label for="">ID Front</label>
                        <input class="form-control" type="file" id="id-front" ref="idFront" @change="handleIDChange">
                    </div>
                    <div class="col-md-2 mt-3">
                        <label for="">ID Back</label>
                        <input class="form-control" type="file" id="id-back" ref="idBack" @change="handleIDChange">
                        
                    </div>
                    <div class="col-md-2" v-if="loading">
                        <div style="margin-top: 50px;">
                            processing ID<img  src="../../assets/images/loader.gif" class="" /> 
                        </div>
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-style-2 btn-small" @click="postUser" style="margin-top: 42px;">Create</button>
                    </div>
                </div>
            </div>


            <h6 class="fw-bold mt-4 mb-0">2. System Users</h6>
            <div class="panel settings-users-panel" style="padding-top: 0px">
                <div class="row">
                    <SkeletonLoader v-if="usersLoading" type="table" :rows="6" :columns="7" />
                    <table
                        v-else
                        id="usersTable"
                        ref="usersTable"
                        class="table table-sm table-hover mb-0"
                        @click="onTableClick"
                    >
                        <thead>
                            <tr>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">No.</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Name</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Role</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Phone</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">System Status</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">User Status</th>
                                <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(user, index) in usersList" :key="user.id" :data-id="user.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ user.name }}</td>
                                <td>{{ user.Permission?.name }}</td>
                                <td>{{ user.phone }}</td>
                                <td>
                                    <span class="badge bg-primary" v-if="user.isSystemUser == true">System User</span>
                                    <span class="badge bg-secondary" v-else>Non-User</span>
                                </td>
                                <td>
                                    <span class="badge bg-success" v-if="user.isActive == true">Active</span>
                                    <span class="badge bg-danger" v-else>Inactive</span>
                                </td>
                                <td>
                                    <button type="button" class="btn-sm btn btn-style-2" data-action="view">View</button>
                                    <div class="btn-group ms-1" role="group">
                                        <button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Action</button>
                                        <ul class="dropdown-menu">
                                            <li v-if="user.isActive == true"><a class="dropdown-item" href="#" :data-id="user.id" data-action="suspend">Suspend User</a></li>
                                            <li v-else><a class="dropdown-item" href="#" :data-id="user.id" data-action="unsuspend">Unsuspend User</a></li>
                                            <li><a class="dropdown-item" href="#" :data-id="user.id" data-action="delete">Delete User</a></li>
                                            <li v-if="user.isActive == true"><a class="dropdown-item" href="#" :data-id="user.id" data-action="password">Reset Password</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="usersList.length === 0">
                                <td colspan="7" class="text-center text-muted">No users found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </section>
  </div>
</AppLayout>
</template>

<script>
import $ from 'jquery'
import 'datatables.net-vue3'
import 'datatables.net-bs5'
import 'datatables.net-buttons-bs5'
import 'datatables.net-responsive-bs5'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.print.js'
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import AppLayout from '../../components/AppLayout.vue'
import SkeletonLoader from '../../components/SkeletonLoader.vue'
import axios from 'axios'

export default {
    name: 'SettingsUsers',
    components: { AppLayout, SkeletonLoader },
    data: () => ({
        token: null,
        url: process.env.VUE_APP_URL,
        name: "",
        email: "",
        phone: "",
        roleId: "",
        isSystemUser: true,
        designation: "",
        employeeId: "",
        phone2: "",
        uploadSignature: "",
        uploadPicture: "",
        upload: "",
        loading: false,
        usersLoading: false,
        dataTable: null,
    }),
    computed: {
        ...mapGetters(["getUsers", "getRoles"]),
        users() { return this.getUsers || [] },
        roles() { return this.getRoles || [] },
        usersList() { return Array.isArray(this.users) ? this.users : [] },
    },
    watch: {
        usersList: {
            handler() { this.$nextTick(() => this.reinitDataTable()) },
            deep: true,
        },
    },
    mounted() {
        try {
            this.token = JSON.parse(localStorage.getItem('access_token'))
        } catch (e) {
            this.token = null
        }
        this.loadUsers()
        this.fetchRoles()
    },
    beforeUnmount() {
        this.destroyDataTable()
    },
    methods: {
        ...mapActions(['fetchUsers', 'fetchRoles']),
        onTableClick(e) {
            const btn = e.target.closest('[data-action]')
            if (!btn) return
            e.preventDefault()
            const row = btn.closest('tr')
            const id = (row && row.dataset.id ? parseInt(row.dataset.id, 10) : null) ||
                (btn.dataset.id ? parseInt(btn.dataset.id, 10) : null)
            if (!id) return
            const action = btn.dataset.action
            if (action === 'view') this.$router.push({ name: 'ViewUser', params: { id } })
            else if (action === 'suspend') this.suspendUser(id)
            else if (action === 'unsuspend') this.unsuspendUser(id)
            else if (action === 'delete') this.deleteUser(id)
            else if (action === 'password') this.passwordUser(id)
        },
        async loadUsers() {
            this.usersLoading = true
            try {
                await this.fetchUsers()
            } catch (e) {
                console.error('Failed to fetch users', e)
            } finally {
                this.usersLoading = false
            }
        },
        reinitDataTable() {
            this.destroyDataTable()
            this.$nextTick(() => setTimeout(() => this.initializeDataTable(), 50))
        },
        initializeDataTable() {
            try {
                const el = this.$refs.usersTable
                if (!el || this.usersList.length === 0) return
                if ($.fn.DataTable.isDataTable(el)) return
                this.dataTable = $(el).DataTable({
                    dom: 'Bfrtip',
                    responsive: true,
                    pageLength: 25,
                    language: {
                      paginate: {
                        previous: '<i class="fas fa-chevron-left"></i>',
                        next: '<i class="fas fa-chevron-right"></i>',
                      },
                    },
                    order: [[1, 'asc']],
                    buttons: [
                        'colvis',
                        'pageLength',
                        { extend: 'csv', text: 'Export CSV', className: 'btn btn-primary btn-sm' },
                        { extend: 'excel', text: 'Export Excel', className: 'btn btn-primary btn-sm' },
                        { extend: 'print', text: 'Print', className: 'btn btn-secondary btn-sm' },
                    ],
                })
            } catch (err) {
                console.warn('DataTable init failed', err)
            }
        },
        destroyDataTable() {
            try {
                const el = this.$refs.usersTable
                if (el && this.dataTable && $.fn.DataTable.isDataTable(el)) {
                    this.dataTable.destroy()
                    this.dataTable = null
                }
            } catch (e) {
                console.warn('DataTable destroy failed', e)
            }
        },
        async postUser () {
            let formData = new FormData()
            formData.append("name", this.name)
            formData.append("upload", this.upload)
            formData.append("picture", this.uploadPicture)
            formData.append("signature", this.uploadSignature)
            formData.append("designation", this.designation)
            formData.append("employeeId", this.employeeId)
            formData.append("isSystemUser", this.isSystemUser)
            formData.append("roleId", this.roleId)
            formData.append("email", this.email)
            formData.append("phone", this.phone)
            formData.append("phone2", this.phone2)
            const requestOptions = {
                method: "POST",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
                body:formData
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users', requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User Created',
                    text: data.message
                })
                await this.fetchUsers()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User not created',
                    text: data.message
                })
            }
        },


        
       async handleIDChange() {
          this.idFront = this.$refs.idFront.files[0];
          this.idBack = this.$refs.idBack.files[0];
          const formaData ={
            front_image: this.idFront,
            back_image: this.idBack
          }
          try{
            this.loading = true
            if(this.idFront !== null &&  this.idBack !== null){
            const response = await axios.post(
              `https://zebra-advanced-manually.ngrok-free.app/kyc/predict?api_key=2683e658-4bd8-4945-aff2-9db67981b674`,
              formaData,
              {
                headers: {
                  'Content-Type': `multipart/form-data`,
  
                },
              }
            )
            const data = response.data.result
            this.name = data.fullName
            this.idNumber = data.idNumber
            console.log("KYC",response)
          }
          }catch(err){
            console.log(err)
          }finally{
            this.loading = false
          }
          
        },





        async suspendUser (userid) {
            const requestOptions = {
                method: "GET",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/suspend/'+userid, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User suspended successfully',
                    text: 'User account suspended and cannot access the system '
                })
                await this.fetchUsers()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User not suspended',
                    text: data.message
                })
            }
        },
        async unsuspendUser(userid) {
            const requestOptions = {
                method: "GET",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/unsuspend/'+userid, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User unsuspended successfully',
                    text: 'User account unsuspended and can now access the system '
                })
                await this.fetchUsers()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User not unsuspended',
                    text: data.message
                })
            }
        },
        async deleteUser(userid) {
            const requestOptions = {
                method: "GET",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/delete/'+userid, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User deleted successfully',
                    text: 'User account deleted'
                })
                await this.fetchUsers()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User not deleted',
                    text: data.message
                })
            }
        },
        async passwordUser(userid) {
            const requestOptions = {
                method: "GET",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/password/'+userid, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User password reset successfully',
                    text: 'User account password reset. Check your phone number for new password'
                })
                await this.fetchUsers()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'User password not reset',
                    text: data.message
                })
            }
        },
        handleFileChange() {
          this.upload = this.$refs.fileUpload.files[0];
          this.uploadSignature = this.$refs.fileSignature.files[0];
          this.uploadPicture = this.$refs.filePicture.files[0];
        }
        
    },
}
</script>

<style lang="scss" scoped>
input {
    border: 1px solid #b4c7e7;
    border-radius: 3px;
}
::placeholder{
    color: black !important;
    opacity: .7 !important;
    text-transform: none !important;
}
.settings-users-page #settings-users .settings-users-container,
.settings-users-page .settings-users-panel,
.settings-users-page .settings-users-panel .row {
  background: transparent !important;
}
.settings-users-page :deep(.dataTables_wrapper),
.settings-users-page :deep(.dataTables_wrapper .dt-scroll-body) {
  background: transparent !important;
}
table{
    margin-left: 11px;
}
th, td{
    text-align: center !important;
}

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                    height: 30px !important;
                  }
                }
              }
            }
          }
        }
      }
  </style>